import React from "react";
import { Coffee, Heart, Sparkles } from "lucide-react";

const TIP_URL = "https://buymeacoffee.com/leonardthepreacher";

export const SupportSection = () => {
    return (
        <section
            id="support"
            data-testid="support-section"
            className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 md:py-24"
        >
            <div
                aria-hidden
                className="absolute inset-0 overflow-hidden pointer-events-none"
            >
                <div className="absolute top-0 left-10 w-80 h-80 rounded-full bg-kickgreen/15 blur-3xl" />
                <div className="absolute bottom-0 right-10 w-80 h-80 rounded-full bg-hotpink/15 blur-3xl" />
            </div>

            <div className="relative bg-black border-4 border-black brutal-shadow-green p-8 md:p-12 grid grid-cols-1 md:grid-cols-5 gap-8 items-center -rotate-[0.5deg]">
                <div className="md:col-span-3">
                    <div className="inline-flex items-center gap-2 mb-3">
                        <Heart className="w-5 h-5 text-hotpink fill-hotpink" />
                        <span className="font-anton uppercase tracking-[0.3em] text-xs text-hotpink">
                            Support the Mission
                        </span>
                    </div>
                    <h2
                        data-testid="support-title"
                        className="font-anton uppercase text-4xl md:text-6xl text-white leading-[0.9] mb-4"
                    >
                        Keep the
                        <br />
                        <span className="text-kickgreen">stream lit</span>.
                    </h2>
                    <p className="font-graffiti text-skyblue text-2xl -rotate-2 mb-4">
                        every coffee counts ✦
                    </p>
                    <p className="font-chivo text-white/80 text-base md:text-lg leading-relaxed max-w-xl">
                        This platform runs on faith, late nights, and your support. If
                        the message has hit you — drop a tip to keep the lights on, the
                        chat moderated, and the gospel pumping through the internet
                        street every single night.
                    </p>
                    <ul className="mt-5 grid grid-cols-1 sm:grid-cols-3 gap-3 font-chivo text-xs text-white/70">
                        <li className="flex items-center gap-2">
                            <Sparkles className="w-4 h-4 text-kickgreen" />
                            One-time or monthly
                        </li>
                        <li className="flex items-center gap-2">
                            <Sparkles className="w-4 h-4 text-hotpink" />
                            Secure via Buy Me a Coffee
                        </li>
                        <li className="flex items-center gap-2">
                            <Sparkles className="w-4 h-4 text-skyblue" />
                            Every $ fuels the next stream
                        </li>
                    </ul>
                </div>

                <div className="md:col-span-2 flex flex-col items-stretch gap-3">
                    <a
                        data-testid="tip-cta-primary"
                        href={TIP_URL}
                        target="_blank"
                        rel="noreferrer"
                        className="group inline-flex items-center justify-center gap-3 bg-kickgreen text-black font-anton uppercase tracking-wider text-2xl px-6 py-5 border-4 border-black hover:-translate-y-1 hover:shadow-[10px_10px_0_#FF2E93] transition-all"
                    >
                        <Coffee
                            className="w-7 h-7 group-hover:rotate-12 transition-transform"
                            strokeWidth={3}
                        />
                        Send a Tip
                    </a>
                    <a
                        data-testid="tip-cta-link"
                        href={TIP_URL}
                        target="_blank"
                        rel="noreferrer"
                        className="text-center font-chivo text-xs text-white/50 hover:text-skyblue break-all"
                    >
                        buymeacoffee.com/leonardthepreacher
                    </a>
                    <div className="mt-2 grid grid-cols-3 gap-2">
                        {["$3", "$10", "$25"].map((amt) => (
                            <a
                                key={amt}
                                data-testid={`tip-amount-${amt.replace("$", "")}`}
                                href={TIP_URL}
                                target="_blank"
                                rel="noreferrer"
                                className="text-center bg-transparent border-2 border-skyblue text-skyblue font-anton uppercase text-lg py-2 hover:bg-skyblue hover:text-black transition-colors"
                            >
                                {amt}
                            </a>
                        ))}
                    </div>
                </div>
            </div>
        </section>
    );
};
